// Liest die Fehlermeldung einer API-Antwort sicher als Text.
// FastAPI liefert `detail` je nach Route als Zeichenkette, bei Validierungsfehlern
// (HTTP 422) als Liste von Objekten und an einigen Stellen als Objekt {code, message}.
// Ein Objekt direkt in einen Toast oder in JSX zu geben beendet den React-Baum
// ("Objects are not valid as a React child") und hinterlässt eine weiße Seite.
export const fehlertext = (error, fallback = 'Etwas ist schiefgelaufen. Bitte erneut versuchen.') => {
  const d = error?.response?.data?.detail;
  if (typeof d === 'string' && d.trim()) return d;
  if (Array.isArray(d)) {
    const msgs = d.map((e) => (typeof e?.msg === 'string' ? e.msg : null)).filter(Boolean);
    return msgs.length ? msgs.join(' ') : fallback;
  }
  if (d && typeof d === 'object' && typeof d.message === 'string' && d.message.trim()) return d.message;
  return fallback;
};

export default fehlertext;
